// extracted by mini-css-extract-plugin
export var body = "_by-0";
export var sectionHeader = "_by-4";
export var shortcutColumns = "_by-2";
export var shortcutList = "_by-1";
export var shortcutSection = "_by-3";